// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1079":"628e5c14","3407":"f751a8a2","8502":"0231c6bb"}[chunkId] + ".chunk.css";
};